import { useSyncExternalStore } from 'react';
import { getThemeMode, subscribeThemeMode } from './themeMode';
import { type ThemeMode } from './types';

const getClientSnapshot = (): ThemeMode => getThemeMode();
const getServerSnapshot = (): ThemeMode => getThemeMode();

export const useThemeMode = (): { mode: ThemeMode } => {
    const mode = useSyncExternalStore(subscribeThemeMode, getClientSnapshot, getServerSnapshot);

    return { mode };
};
